import { fromClass } from "fw-model";

export class AtsApplicationMetaData {
    IndexErrorMessage: string;
}

export class AtsApplication {
    Id: string;
    @fromClass MetaData: AtsApplicationMetaData;
}
